import { escapeRegExp, isEmpty } from 'lodash';

import Pathway from '../models/Pathway';

class PathwayService {
  public filterPathwaysBy(pathways: Pathway[], searchText: string) {
    if (!searchText) {
      return pathways;
    }
    const regexp = new RegExp(escapeRegExp(searchText), 'i');
    const filteredPathways = pathways.filter((pathway) =>
      regexp.test(pathway.title)
    );

    return filteredPathways;
  }

  public filterByStatus(pathways: Pathway[], status: string[]) {
    if (isEmpty(status)) {
      return pathways;
    }
    const filteredPathways = pathways.filter((pathway) =>
      status.some((s) => s === pathway.status)
    );

    return filteredPathways;
  }
}

export default new PathwayService();
